"use strict";

exports.__esModule = true;
exports.PathAttachment = void 0;

var _Utils = require("../Utils");

var _Attachment = require("./Attachment");

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/** An attachment whose vertices make up a composite Bezier curve.
 *
 * See {@link PathConstraint} and [Paths](http://esotericsoftware.com/spine-paths) in the Spine User Guide. */
var PathAttachment = /*#__PURE__*/function (_VertexAttachment) {
  _inheritsLoose(PathAttachment, _VertexAttachment);

  function PathAttachment(name) {
    var _this;

    _this = _VertexAttachment.call(this, name) || this;
    /** The lengths along the path in the setup pose from the start of the path to the end of each Bezier curve. */

    _this.lengths = null;
    /** If true, the start and end knots are connected. */

    _this.closed = false;
    /** If true, additional calculations are performed to make calculating positions along the path more accurate. If false, fewer
     * calculations are performed but calculating positions along the path is less accurate. */

    _this.constantSpeed = false;
    /** The color of the path as it was in Spine. Available only when nonessential data was exported. Paths are not usually
     * rendered at runtime. */

    _this.color = new _Utils.Color(1, 1, 1, 1);
    return _this;
  }

  var _proto = PathAttachment.prototype;

  _proto.copy = function copy() {
    var copy = new PathAttachment(this.name);
    this.copyTo(copy);
    copy.lengths = new Array(this.lengths.length);

    _Utils.Utils.arrayCopy(this.lengths, 0, copy.lengths, 0, this.lengths.length);

    copy.closed = closed;
    copy.constantSpeed = this.constantSpeed;
    copy.color.setFromColor(this.color);
    return copy;
  };

  return PathAttachment;
}(_Attachment.VertexAttachment);

exports.PathAttachment = PathAttachment;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUE2QkE7O0FBQ0E7Ozs7OztBQUVBOzs7SUFHYUEsYzs7O0VBZ0JaLHdCQUFhQyxJQUFiLEVBQXlCO0lBQUE7O0lBQ3hCLHFDQUFNQSxJQUFOO0lBZkQ7O0lBQ0EsZ0JBQXlCLElBQXpCO0lBRUE7O0lBQ0EsZUFBUyxLQUFUO0lBRUE7OztJQUVBLHNCQUFnQixLQUFoQjtJQUVBOzs7SUFFQSxjQUFRLElBQUlDLFlBQUosQ0FBVSxDQUFWLEVBQWEsQ0FBYixFQUFnQixDQUFoQixFQUFtQixDQUFuQixDQUFSO0lBRXlCO0VBRXhCOzs7O1NBRURDLEksR0FBQSxnQkFBSTtJQUNILElBQUlBLElBQUksR0FBRyxJQUFJSCxjQUFKLENBQW1CLEtBQUtDLElBQXhCLENBQVg7SUFDQSxLQUFLRyxNQUFMLENBQVlELElBQVo7SUFDQUEsSUFBSSxDQUFDRSxPQUFMLEdBQWUsSUFBSUMsS0FBSixDQUFrQixLQUFLRCxPQUFMLENBQWFFLE1BQS9CLENBQWY7O0lBQ0FDLGFBQU1DLFNBQU4sQ0FBZ0IsS0FBS0osT0FBckIsRUFBOEIsQ0FBOUIsRUFBaUNGLElBQUksQ0FBQ0UsT0FBdEMsRUFBK0MsQ0FBL0MsRUFBa0QsS0FBS0EsT0FBTCxDQUFhRSxNQUEvRDs7SUFDQUosSUFBSSxDQUFDTyxNQUFMLEdBQWNBLE1BQWQ7SUFDQVAsSUFBSSxDQUFDUSxhQUFMLEdBQXFCLEtBQUtBLGFBQTFCO0lBQ0FSLElBQUksQ0FBQ1MsS0FBTCxDQUFXQyxZQUFYLENBQXdCLEtBQUtELEtBQTdCO0lBQ0EsT0FBT1QsSUFBUDtFQUNBLEM7OztFQTdCa0NXLDRCIiwibmFtZXMiOlsiUGF0aEF0dGFjaG1lbnQiLCJuYW1lIiwiQ29sb3IiLCJjb3B5IiwiY29weVRvIiwibGVuZ3RocyIsIkFycmF5IiwibGVuZ3RoIiwiVXRpbHMiLCJhcnJheUNvcHkiLCJjbG9zZWQiLCJjb25zdGFudFNwZWVkIiwiY29sb3IiLCJzZXRGcm9tQ29sb3IiLCJWZXJ0ZXhBdHRhY2htZW50Il0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hdHRhY2htZW50cy9QYXRoQXR0YWNobWVudC50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==